import { inject, Injectable } from '@angular/core';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';
import { HttpClient } from '@angular/common/http';
import { HealthRecordMeta } from '@web/csl-lib-models';

@Injectable({
  providedIn: 'root'
})
export class HealthRecordMetaService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getHealthRecordMeta(healthRecordId: string) {
    return this.http.get<HealthRecordMeta>(`${this.apiUrl}/healthrecords/${healthRecordId}/meta`);
  }


}
